// localStorage.setItem('token',1) // 测试token
import Vue from "vue";
import '@/utils/lib-flexible';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
import App from "./App.vue";
import router from "./router";
import store from "./store";
import '@/icons' // icon
import '@/permission' // permission control
import '@/static/styles/index.less' // global css
import '@/static/styles/calc.less' // calc css

import {
  baseImgUrl
} from "@/utils/pageConf";

import Vant from 'vant'
import 'vant/lib/index.css';
Vue.use(Vant);

let scrollOptions = {
   container: "body", //滚动的容器
   duration: 500, //滚动时间
   easing: "ease", //缓动类型
   offset: 0, // 滚动时应应用的偏移量。此选项接受回调函数
   force: true, // 是否应执行滚动
   cancelable: true, // 用户是否可以取消滚动
   onStart: false, // 滚动开始时的钩子函数
   onDone: false, // 滚动结束时候的钩子函数
   onCancel: false, // 用户取消滚动的钩子函数
   x: false, // 是否要在x轴上也滚动
   y: true  // 是否要在y轴上滚动
  }
  import VueScrollTo from 'vue-scrollto'
  Vue.use(VueScrollTo,scrollOptions)

import vueAwesomeCountdown from 'vue-awesome-countdown'
Vue.use(vueAwesomeCountdown, 'vac')

import md5 from 'js-md5';
Vue.prototype.$md5 = md5;

import '@/assets/font/fonts.css'

// import Swiper ,{Autoplay}from "swiper";
// Swiper.use([Autoplay])

import 'swiper/swiper-bundle.min.css'

Vue.use(ElementUI);
// 混入
import mixin from "@/mixin";
Vue.mixin(mixin);
// 过滤器
import * as filters from "@/utils/filters";
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]); //插入过滤器名和对应方法
});
//全局公共方法
import common from './util/js/common.js' //公共方法，加入vue的原型链
Vue.prototype.$EventBus = new Vue()
Vue.prototype.$common = common;/* 引入resize计算模块 */
Vue.config.productionTip = false;
Vue.prototype.$baseUrl = process.env.VUE_APP_BASE_API // 可以直接在view层标签使用
Vue.prototype.$baseImgUrl = baseImgUrl // 可以直接在view层标签使用
import resize from "vue-element-resize-detector";
Vue.use(resize)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");